import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@afosto/app-components-react/Dialog';
import translations from './translations';

const PickFinishedDialog = ({ isOpen }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push('/shipments');
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        <FormattedMessage {...translations.title} />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage {...translations.message} />
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={handleClick}>
          <FormattedMessage {...translations.actions.continue} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PickFinishedDialog.propTypes = {
  isOpen: PropTypes.bool,
};

PickFinishedDialog.defaultProps = {
  isOpen: false,
};

export default PickFinishedDialog;
